module.exports = __webpack_public_path__ + "static/media/1.6129f866.png";